module.exports = __webpack_public_path__ + "media/tracking/Cody-c22221dc.jpg";